"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.distributorRoutes = exports.protectedRoutes = exports.publicRoutes = void 0;
const ChangeCredentials_1 = __importDefault(require("~/components/Account/ChangeCredentials/ChangeCredentials"));
const ProfileModal_1 = __importDefault(require("~/components/Account/ProfileModal/ProfileModal"));
const TeamModal_1 = __importDefault(require("~/components/Account/TeamModal"));
const InviteTeamMember_1 = __importDefault(require("~/components/Account/TeamModal/InviteTeamMember"));
const Authorization_1 = __importDefault(require("~/components/Authorization"));
const ProjectsModal_1 = __importDefault(require("~/components/ProjectManagement/ProjectsModal"));
const routes_1 = require("~/consts/routes");
const CreateProjectModal_1 = __importDefault(require("~/components/ProjectManagement/CreateProjectModal"));
const EditProjectModal_1 = __importDefault(require("~/components/ProjectManagement/EditProjectModal"));
const ErrorModals_1 = require("~/components/ErrorModals");
const CustomersModal_1 = __importDefault(require("~/components/CustomersManagement/CustomersModal"));
const AddCustomerModal_1 = __importDefault(require("~/components/CustomersManagement/AddCustomerModal"));
const EditCustomerModal_1 = __importDefault(require("~/components/CustomersManagement/EditCustomerModal"));
exports.publicRoutes = [
    {
        path: routes_1.ROUTE_HOME,
        Components: [],
    },
    {
        path: routes_1.ROUTE_VIEWER,
        Components: [],
    },
    {
        path: routes_1.ROUTE_LOGIN,
        Components: [Authorization_1.default],
    },
    {
        path: routes_1.ROUTE_SIGNUP,
        Components: [Authorization_1.default],
    },
    {
        path: routes_1.RESTORE_PASSWORD,
        Components: [Authorization_1.default],
    },
    {
        path: routes_1.ROUTE_SIGNOUT,
        Components: [Authorization_1.default],
    },
    {
        path: routes_1.ROUTE_NOT_FOUND,
        Components: [ErrorModals_1.NotFoundModal],
    },
];
exports.protectedRoutes = [
    {
        path: routes_1.ROUTE_PROFILE,
        Components: [ProfileModal_1.default],
    },
    {
        path: routes_1.ROUTE_TEAM,
        Components: [TeamModal_1.default],
    },
    {
        path: routes_1.INVITE_TEAM_MEMBER,
        Components: [InviteTeamMember_1.default],
    },
    {
        path: routes_1.ROUTE_PROJECTS,
        Components: [ProjectsModal_1.default],
    },
    {
        path: routes_1.ROUTE_PROJECT,
        Components: [],
    },
    {
        path: routes_1.ROUTE_CREATE_PROJECT,
        Components: [CreateProjectModal_1.default],
    },
    {
        path: routes_1.ROUTE_EDIT_PROJECT,
        Components: [EditProjectModal_1.default],
    },
    {
        path: routes_1.CHANGE_PASSWORD,
        Components: [ChangeCredentials_1.default],
    },
    {
        path: routes_1.CHANGE_EMAIL,
        Components: [ChangeCredentials_1.default],
    },
];
exports.distributorRoutes = [
    {
        path: routes_1.ROUTE_CUSTOMERS,
        Components: [CustomersModal_1.default],
    },
    {
        path: routes_1.ROUTE_ADD_CUSTOMER,
        Components: [AddCustomerModal_1.default],
    },
    {
        path: routes_1.ROUTE_EDIT_CUSTOMER,
        Components: [EditCustomerModal_1.default],
    },
];
